import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import * as Yup from "yup";
import React, { ChangeEvent } from "react";
import { v4 as uuidv4 } from "uuid";
import { FormikProps } from "formik";
import { styled } from "@mui/material";
import { PdfIcon, DocIcon, DocxIcon } from "./assets";
import { scrollToTop } from "../../../components/src/utils";

const AttachmentPreview = styled("img")({
  width: 90,
  height: 90,
  objectFit: "cover",
  borderRadius: 4,
});

export const userSchema = () => {
  return Yup.object().shape({
    firstName: Yup.string()
      .matches(/^[A-Za-z]+$/, "Only alphabets are allowed!")
      .max(30, "First name must be at most 30 characters!")
      .required("First name is required!"),
    lastName: Yup.string()
      .matches(/^[A-Za-z]+$/, "Only alphabets are allowed!")
      .max(30, "Last name must be at most 30 characters!")
      .required("Last name is required!"),
    phoneNumber: Yup.string()
      .matches(/^\d{10}$/, "Phone number must contain exactly 10 digits!")
      .required("Phone number is required!"),
    email: Yup.string()
      .email("Invalid email format!")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "*Invalid email format!"
      )
      .required("Email is required!"),
    subject: Yup.string()
      .max(50, "Subject cannot exceed 50 characters!")
      .required("Subject is required!"),
    message: Yup.string()
      .max(500, "Message cannot exceed 500 characters!")
      .required("Message is required!"),
  });
};

interface IContactUsValues {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  subject: string;
  message: string;
}

interface IContactUsSuccessResponse {
  data: {
    id: string;
    type: string;
    attributes: {
      first_name: string;
      last_name: string;
      email: string;
      full_phone_number: string;
      subject: string;
      message: string;
    };
  };
}

interface IContactUsImageSuccessResponse {
  data: {
    id: string;
    type: "admin_contact_image";
    attributes: {
      image_url: string;
    };
  };
}

interface IContactUsErrorResponse {
  errors: { contact: string[] }[];
}

enum FilesEnum {
  IMAGE = "image",
  DOCUMENT = "document",
}

interface IAttachment {
  id: string;
  file: File;
  fileType: FilesEnum;
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  subject: string;
  phoneNumber: string;
  comments: string;
  enableField: boolean;
  token: string;
  contactUsList: any;
  activeId: number;
  activeName: string;
  activeEmail: string;
  activePhoneNumber: string;
  activeDescription: string;
  activeCreatedAt: string;
  isVisible: boolean;
  message: string;
  fileError: string;
  isModalOpen: boolean;
  isLoading: boolean;
  attachments: IAttachment[];
  contactUsImage: string;
  isGettingCUImage: boolean
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class ContactusController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  contactUsApiCallId: any;
  deleteContactApiCallId: any;
  addContactApiCallId: any;
  sendContactUsDataApiCallId: string = "";
  contactUsImageApiCallId: string = "";
  formikRef = React.createRef<FormikProps<IContactUsValues>>();
  // Customizable Area End
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage),
    ];

    this.contactUsApiCallId = "";
    this.deleteContactApiCallId = "";
    this.addContactApiCallId = "";

    this.state = {
      name: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      comments: "",
      enableField: false,
      token: "",
      contactUsList: [],
      activeId: 0,
      activeName: "",
      activeEmail: "",
      activePhoneNumber: "",
      activeDescription: "",
      activeCreatedAt: "",
      isVisible: false,
      message: "",
      subject: "",
      fileError: "",
      isModalOpen: false,
      isLoading: false,
      attachments: [],
      contactUsImage: "",
      isGettingCUImage: false
    };

    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    super.componentDidMount();
    this.getToken();
    scrollToTop(true);
    // Customizable Area Start
    this.getContactUsImage();
    if (this.isPlatformWeb() === false) {
      this.props.navigation.addListener("willFocus", () => {
        this.getToken();
      });
    }
    // Customizable Area End
  }

  getToken = () => {
    const msg: Message = new Message(
      getName(MessageEnum.SessionRequestMessage)
    );
    this.send(msg);
  };

  getTokens = () => {
    const msg: Message = new Message(
      getName(MessageEnum.SessionRequestMessage)
    );
    this.send(msg);
  };

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.SessionResponseMessage) === message.id) {
      let token = message.getData(getName(MessageEnum.SessionResponseToken));
      this.setState({ token: token });
    } else if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (responseJson && responseJson.data) {
        if (apiRequestCallId === this.contactUsApiCallId) {
          this.setState({ contactUsList: responseJson.data });
        }
        if (apiRequestCallId === this.addContactApiCallId) {
          this.props.navigation.goBack();
        }

        if (apiRequestCallId === this.contactUsImageApiCallId) {
          const {
            data: {
              attributes: { image_url },
            },
          } = responseJson as IContactUsImageSuccessResponse;
          this.setState({
            contactUsImage: image_url,
            isGettingCUImage: false,
          });
        }
      } else if (
        responseJson &&
        responseJson.message &&
        apiRequestCallId === this.deleteContactApiCallId
      ) {
        this.setState({ isVisible: false });
        this.getContactUsList(this.state.token);
      } else if (responseJson.errors) {
        if (apiRequestCallId === this.addContactApiCallId) {
          responseJson.errors.forEach((error: any) => {
            if (error.contact) {
              this.showAlert(configJSON.errorTitle, error.contact.join("."));
            }
          });
        }

        if (apiRequestCallId === this.contactUsImageApiCallId) {
          this.setState({ isGettingCUImage: false });
        }
      }

      this.handleWebResponses(apiRequestCallId, responseJson);
    }
    // Customizable Area End
  }

  // Customizable Area Start
  txtNameProps = {
    onChangeText: (text: string) => {
      this.setState({ name: text });

      //@ts-ignore
      this.txtNameProps.value = text;
    },
  };

  txtEmailProps = {
    onChangeText: (text: string) => {
      this.setState({ email: text });

      //@ts-ignore
      this.txtEmailProps.value = text;
    },
  };
  txtPhoneNumberProps = {
    onChangeText: (text: string) => {
      this.setState({ phoneNumber: text });

      //@ts-ignore
      this.txtPhoneNumberProps.value = text;
    },
    // keyboardType: "phone-pad"
  };
  txtCommentsProps = {
    multiline: true,
    onChangeText: (text: string) => {
      this.setState({ comments: text });

      //@ts-ignore
      this.txtCommentsProps.value = text;
    },
  };

  setName = (text: string) => {
    this.setState({ name: text });
  };
  setFirstName = (text: string) => {
    this.setState({ firstName: text });
  };
  setLastName = (text: string) => {
    this.setState({ lastName: text });
  };

  setEmail = (text: string) => {
    this.setState({ email: text });
  };

  setPhoneNumber = (text: string) => {
    this.setState({ phoneNumber: text });
  };

  setComments = (text: string) => {
    this.setState({ comments: text });
  };
  setMessage = (text: string) => {
    this.setState({ message: text });
  };
  setSubject = (text: string) => {
    this.setState({ subject: text });
  };
  addQuery = () => {
    this.props.navigation.navigate("AddContactus");
  };

  hideModal = () => {
    this.setState({ isVisible: !this.state.isVisible });
  };

  setModal = (item: any) => {
    this.setState({
      activeId: item.id,
      activeName: item.attributes.name,
      activeEmail: item.attributes.email,
      activeDescription: item.attributes.description,
      activePhoneNumber: item.attributes.phone_number,
      activeCreatedAt: item.attributes.created_at,
      isVisible: !this.state.isVisible,
    });
  };

  setCloseSuccess = () => {
    this.setState({ isModalOpen: false });
  };

  isStringNullOrBlank(str: string) {
    return str === null || str.length === 0;
  }

  isValidEmail = (Email: string) => {
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (reg.test(Email) === false) {
      return false;
    } else {
      return true;
    }
  };

  addQueryApi = () => {
    if (
      this.isStringNullOrBlank(this.state.name) ||
      this.isStringNullOrBlank(this.state.email) ||
      this.isStringNullOrBlank(this.state.phoneNumber) ||
      this.isStringNullOrBlank(this.state.comments)
    ) {
      this.showAlert(
        configJSON.errorTitle,
        configJSON.errorAllFieldsAreMandatory
      );
      return false;
    } else if (!this.isValidEmail(this.state.email.trim())) {
      this.showAlert(configJSON.errorTitle, configJSON.errorEmailNotValid);
      return false;
    } else {
      let data = {
        data: {
          name: this.state.name.trim(),
          email: this.state.email.trim(),
          phone_number: this.state.phoneNumber.trim(),
          description: this.state.comments.trim(),
        },
      };

      const header = {
        "Content-Type": configJSON.contactUsApiContentType,
        token: this.state.token,
      };
      const requestMessage = new Message(
        getName(MessageEnum.RestAPIRequestMessage)
      );

      this.addContactApiCallId = requestMessage.messageId;

      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        configJSON.getContactUsAPiEndPoint
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify(header)
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        JSON.stringify(data)
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestMethodMessage),
        configJSON.httpPostMethod
      );
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    }
  };

  deleteContactUs = (id: number) => {
    const header = {
      token: this.state.token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.deleteContactApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getContactUsAPiEndPoint + `/${id}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpDeleteMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  };

  getContactUsList = (token: string) => {
    const header = {
      "Content-Type": configJSON.contactUsApiContentType,
      token: token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.contactUsApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getContactUsAPiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  btnSubmitProps = {
    onPress: () => this.addQueryApi(),
  };

  btnBackProps = {
    onPress: () => this.props.navigation.goBack(),
  };

  handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files;
    if (!selectedFiles) return;

    this.setState((prevState) => {
      const attachments = [...prevState.attachments];
      let totalSizeMB = attachments.reduce(
        (total, { file }) => total + file.size / (1024 * 1024),
        0
      );
      let fileError = "";

      Array.from(selectedFiles).forEach((file) => {
        const fileExtension = file.name.split(".").pop()?.toLowerCase();
        if (
          !fileExtension ||
          !configJSON.ALLOWED_FILE_EXTENSIONS.includes(fileExtension)
        ) {
          fileError = configJSON.invalidFileTypeErrorText;
          return;
        }

        const newTotalSizeMB = totalSizeMB + file.size / (1024 * 1024);
        if (newTotalSizeMB > 10) {
          fileError = configJSON.maxSizeFileErrorText;
          return;
        }

        totalSizeMB = newTotalSizeMB;
        const uniqueId = uuidv4();
        const fileType = configJSON.ALLOWED_DOCUMENT_TYPES.includes(
          fileExtension
        )
          ? FilesEnum.DOCUMENT
          : FilesEnum.IMAGE;
        attachments.push({ id: uniqueId, file, fileType });
      });

      return { attachments, fileError };
    });
  };

  handleRemoveAttachment = (attachmentId: string) => {
    const updatedList = [...this.state.attachments].filter(
      (fileInfo) => fileInfo.id !== attachmentId
    );
    this.setState({ attachments: updatedList });
  };

  renderFilePreview = (fileInfo: IAttachment) => {
    const { file, fileType } = fileInfo;
    const filePreview = URL.createObjectURL(file);

    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    const IconByExt: Record<string, string> = {
      pdf: PdfIcon,
      doc: DocIcon,
      docx: DocxIcon,
    };

    const imgSrc =
      fileType === FilesEnum.IMAGE ? filePreview : IconByExt[fileExtension!];

    return <AttachmentPreview src={imgSrc} alt="File Preview" />;
  };

  contactUsApi = (formData: FormData) => {
    const header = {};

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.sendContactUsDataApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.sendContactUsApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  };

  getContactUsImage = () => {
    this.setState({ isGettingCUImage: true });
    const header = {
      "Content-Type": configJSON.contactUsApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.contactUsImageApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.contactUsImageApiEndpoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleContactUsSubmit = (values: IContactUsValues) => {
    const { email, firstName, lastName, message, phoneNumber, subject } =
      values;
    const { attachments } = this.state;

    this.setState({ isLoading: true, fileError: "" });
    const formData = new FormData();
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("email", email.trim());
    formData.append("subject", subject);
    formData.append("message", message);
    formData.append("full_phone_number", phoneNumber);

    attachments.forEach((fileInfo) => {
      formData.append("contact_images[]", fileInfo.file);
    });

    this.contactUsApi(formData);
  };

  handleWebResponses = (
    apiRequestCallId: string,
    responseJson: IContactUsSuccessResponse | IContactUsErrorResponse
  ) => {
    if (apiRequestCallId === this.sendContactUsDataApiCallId) {
      if ("data" in responseJson) {
        this.setState({ isModalOpen: true, isLoading: false, attachments: [] });
        if (this.formikRef.current) {
          this.formikRef.current.resetForm();
        }
      } else {
        this.setState({ isLoading: false });
      }
    }
  };
  // Customizable Area End
}
